import axios from 'axios';
import { API_BASE_URL, getAxiosRequestConfig } from './apiBase';
import IFeedback from '../models/iFeedback';
import { IHelpRequest, IHelpRequestResponse } from '../models/iHelpRequest';

export const submitFeedback = async (bearerToken: string, feedback: IFeedback, logId: string): Promise<void> => {
  return await axios.post(
    `${API_BASE_URL}/Feedback/submit`,
    feedback,
    getAxiosRequestConfig(bearerToken, { logId: logId })
  );
};

export const submitHelpRequest = async (
  bearerToken: string,
  helpRequest: IHelpRequest
): Promise<IHelpRequestResponse> => {
  const response = await axios.post(
    `${API_BASE_URL}/Feedback/request-help`,
    helpRequest,
    getAxiosRequestConfig(bearerToken)
  );
  return response.data;
};
